import { ExternalMedia } from './external-media';

/* Copyright CADS
 *
 * All rights are reserved. Reproduction or transmission in whole or in part, in
 * any form or by any means, electronic, mechanical or otherwise, is prohibited
 * without the prior written consent of the copyright owner.
 *
 * THIS FILE IS AUTO GENERATED DO NOT EDIT IT MANULLY
 *
 */

export class EditVariationInstructionCommand {
  VariationId: string;
  SiteInstructionReference: string;
  SiteInstructionReceivedFromId: string;
  Notes: string;
  Scaffolds: string[];
  Media: ExternalMedia[];
  SubmittedForPricing: boolean;
  EstimatorId: string;
  ContractPrice: number;
  ExtraHireRate: number;
  HirePeriod: number;
  SendEmailToEstimator: boolean;
  OwnerId: string;
  CommandVersion: string;
  SourceApp: string;
  SourceAppVersion: string;
}


